import { z } from 'zod';
const isoDateRegExp = new RegExp(
  /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/,
);

export const REQUIRED_MESSAGE = 'app.common.validations.required_field';
export const GREATER_THAN_TODAY_MESSAGE =
  'app.common.assert.err_greater_than_today';
function isISODate(str: string) {
  return isoDateRegExp.test(str);
}
export const isoDateSchema = z.string().refine(isISODate, {
  error: 'Not a valid ISO string date',
});
export const fileSchema = z.instanceof(File, {
  message: REQUIRED_MESSAGE,
});

export const MAX_LENGTH_MESSAGE = 'app.common.validations.string_max_length';
export const EMAIL_MESSAGE = 'app.common.validations.email.invalid';
export const PASSWORD_MESSAGE = 'app.common.validations.password.mismatch';

export const requiredString = z
  .string({
    error: REQUIRED_MESSAGE,
  })
  .trim()
  .min(1, REQUIRED_MESSAGE);

export const optionalString = z.string();

export const requiredNumber = z.number({
  error: (issue) =>
    issue.input === undefined ? REQUIRED_MESSAGE : REQUIRED_MESSAGE,
});
export const optionalEmail = z.union([z.literal(''), z.email()]);
export const requiredEmail = z.email(EMAIL_MESSAGE);

export const requiredDate = z.date({
  error: (issue) =>
    issue.input === undefined ? REQUIRED_MESSAGE : REQUIRED_MESSAGE,
});
